export default __webpack_public_path__ + "static/media/dindatwo.baa60048.jpeg";